import { Injectable } from '@angular/core';
import { BaseService } from "../base/base.service";
import { ContentFactory } from '../../squidex';

@Injectable({ providedIn: 'root' })
export class LanguageService extends BaseService {

    constructor(contentFactory: ContentFactory) {
        super('language', contentFactory);
    }
}
